import { createReducer, on } from '@ngrx/store';
import * as orgActions from '../actions/organization.actions';

export const initialOrgState = null;

export const orgReducer = createReducer(
    initialOrgState,
    on(orgActions.GetOrganizationSuccess, (state, action) => {
        localStorage.setItem('organization', JSON.stringify(action.organization));
        localStorage.setItem('organizationAccount', JSON.stringify(action.organizationAccount));
        return Object.assign(
            {},
            {
                organization: action.organization,
                organizationAccount: action.organizationAccount,
            }
        );
    }),
    on(orgActions.ClearOrganization, (state, action) => initialOrgState)
);


export const searchOrgReducer = createReducer(
    initialOrgState,
    on(orgActions.SearchOrganizationSuccess, (state, action) => {
        return action.searchedOrganizations;
    }),
    on(orgActions.ClearSearchOrganization, (state, action) => initialOrgState)
);
